import {
  GlobalDesignActionType,
  GlobalDesignGroupAction,
  ComparisonMode,
} from '../types';
import { filterGrouping } from './grouping';
import FilterStyles from './FilterStyles';
import { filterGroupDisplayFilter } from './groupDisplayFilter';
import FilterLobbyItem from './FilterLobbyItem';

const filterAction: GlobalDesignGroupAction = {
  type: GlobalDesignActionType.Group,
  panel: FilterStyles,
  lobbyItem: FilterLobbyItem,
  comparisonMode: ComparisonMode.DirectProps,
  grouping: filterGrouping,
  groupDisplayFilter: filterGroupDisplayFilter,
};

export default filterAction;
